export default "__VITE_ASSET__CuRAd0HB__"